import { render, staticRenderFns } from "./RecieveSampleCheckbox.vue?vue&type=template&id=6aa2e829"
import script from "./RecieveSampleCheckbox.vue?vue&type=script&lang=js"
export * from "./RecieveSampleCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports